import { Component } from 'preact';
import { getRulesLanguage, setRulesLanguage, subscribeRulesLanguage } from '../localization/preferences';
import { rulesLabel } from '../localization/rules';
import { LANGUAGES } from '../localization/languages';
import { Select } from './ui/select';

// Language names stay in their own language so a reader who picked the
// wrong one can still find the way back.
const OPTIONS = LANGUAGES.map(({ code, label }) => ({ value: code, label }));

export default class RulesLanguageSwitch extends Component {
  state = { language: getRulesLanguage() };

  componentDidMount() {
    this.unsubscribe = subscribeRulesLanguage(language => this.setState({ language }));
  }

  componentWillUnmount() {
    this.unsubscribe?.();
  }

  render() {
    const { language } = this.state;
    return (
      <Select
        ariaLabel={rulesLabel('Rules language', language)}
        options={OPTIONS}
        value={language}
        onValueChange={setRulesLanguage}
        triggerClassName="w-40 shrink-0"
        menuPreferredWidth={160}
        portalMenu
      />
    );
  }
}
